module.exports = __webpack_public_path__ + "static/img/withdraw-gift.adb605e1.png";